export enum UserServiceApiEndpoints {
    SET_PASSWORD_USING_PIN = '/v1/user/occupant/set-password',
    VALIDATE_TAX_ID = '/v1/user/validate-tax-id?taxId={taxId}',
    USER_HAS_BOOKINGS = '/v1/user/bookings',
    SPANISH_TAX_INFO = '/v1/user/spanish-tax-info',
}
